const VALID_PERPETUAL = 'perpetual';

export { VALID_PERPETUAL };
